import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const settingOption = new Restful(project, 'setting/option')

settingOption.global = function(data) {
  const url = project + 'setting/option/global'
  return http.get(url, data).then(res => {
    return res
  })
}

settingOption.queryOption = function(type, data) {
  const url = project + `setting/option/${type}/${data}`
  return http.get(url, type, data).then(res => {
    return res
  })
}
settingOption.enabled = function(id, data) {
  const url = project + `setting/option/enabled/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

const settingCountry = new Restful(project, 'setting/country')
settingCountry.queryOption = function(data) {
  const url = project + `setting/country/name`
  return http.get(url, data).then(res => {
    return res
  })
}

const settingAtype = new Restful(project, 'setting/atype')

settingAtype.queryOption = function(data) {
  const url = project + `setting/atype/name`
  return http.get(url, data).then(res => {
    return res
  })
}

// file upload
const settingContent = new Restful(project, 'setting/file')

// 期刊级

const settingJournal = new Restful(project, 'setting/journal')
settingJournal.copy = function(data) {
  const url = project + 'setting/journal/copy'
  return http.put(url, data).then(res => {
    return res
  })
}

const settingJournalCountry = new Restful(project, 'setting/journal/country')
// 【期刊-国家】查询各种制裁国家列表
settingJournalCountry.sanction = function(id) {
  const url = project + 'setting/journal/country/sanction/' + id
  return http.get(url).then(res => {
    return res
  })
}
// 【期刊-国家】设置分区
settingJournalCountry.setSanction = function(id, data = {}) {
  const url = project + 'setting/journal/country/sanction/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
// 【期刊-国家】期刊下的国家分区列表
settingJournalCountry.zone = function(id) {
  const url = project + 'setting/journal/country/zone/' + id
  return http.get(url).then(res => {
    return res
  })
}
// 【期刊-国家】设置分区
settingJournalCountry.setZone = function(id, data = {}) {
  const url = project + 'setting/journal/country/zone/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

const settingJournalAtype = new Restful(project, 'setting/journal/atype')
settingJournalAtype.queryAll = function(data) {
  const url = project + 'setting/journal/atype/all/query'
  return http.get(url, data).then(res => {
    return res
  })
}
// 【期刊-文章类型】期刊下的文章类型出版建议列表
settingJournalAtype.publishSuggestion = function(id) {
  const url = project + 'setting/journal/atype/publish_suggestion/' + id
  return http.get(url).then(res => {
    return res
  })
}
// 【期刊-文章类型】设置出版建议
settingJournalAtype.setPublishSuggestion = function(id, data = {}) {
  const url = project + 'setting/journal/atype/publish_suggestion/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
// 【期刊-文章类型】期刊下的文章类型启禁用列表
settingJournalAtype.used = function(id) {
  const url = project + 'setting/journal/atype/used/' + id
  return http.get(url).then(res => {
    return res
  })
}
// 【期刊-文章类型】设置启禁用
settingJournalAtype.setUsed = function(id, data = {}) {
  const url = project + 'setting/journal/atype/used/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

const settingJournalAtypeAlert = new Restful(
  project,
  'setting/journal/atype/alert'
)

settingJournalAtypeAlert.copy = function(data) {
  const url = project + 'setting/journal/atype/alert/copy'
  return http.post(url, data).then(res => {
    return res
  })
}

const settingJournalLanguage = new Restful(project, 'setting/journal/language')

export {
  settingOption,
  settingCountry,
  settingAtype,
  settingJournal,
  settingJournalCountry,
  settingJournalAtype,
  settingJournalAtypeAlert,
  settingContent,
  settingJournalLanguage
}
